/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u1h_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why do practice exams use 1-hour sections?`)
};

const es_timer_u1h_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué los exámenes de práctica usan secciones de 1 hora?`)
};

const de_timer_u1h_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum nutzen Übungsklausuren 1-Stunden-Abschnitte?`)
};

const nl_timer_u1h_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom gebruiken proefexamens onderdelen van 1 uur?`)
};

const fr_timer_u1h_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi les examens blancs utilisent-ils des sections d’une heure ?`)
};

const it_timer_u1h_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché gli esami di pratica usano sezioni di 1 ora?`)
};

const pt_br2_timer_u1h_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que os simulados usam seções de 1 hora?`)
};

const pt_timer_u1h_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque é que os exames de prática usam secções de 1 hora?`)
};

const ja_timer_u1h_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`なぜ模擬試験は1時間単位のセクションを使うのですか？`)
};

const zh_timer_u1h_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么模拟考试常采用1小时的分段？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u1h_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u1h_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u1h_faq4_q", locale)
	if (locale === "en") return en_timer_u1h_faq4_q(inputs)
	if (locale === "es") return es_timer_u1h_faq4_q(inputs)
	if (locale === "de") return de_timer_u1h_faq4_q(inputs)
	if (locale === "nl") return nl_timer_u1h_faq4_q(inputs)
	if (locale === "fr") return fr_timer_u1h_faq4_q(inputs)
	if (locale === "it") return it_timer_u1h_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u1h_faq4_q(inputs)
	if (locale === "pt") return pt_timer_u1h_faq4_q(inputs)
	if (locale === "ja") return ja_timer_u1h_faq4_q(inputs)
	return zh_timer_u1h_faq4_q(inputs)
};